import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantContextService } from 'app/@core/services/utility/tenant-context.service';
import { firstValueFrom } from 'rxjs';

export const SuperAdminGuard: CanActivateFn = async () => {
    const tenantCtx = inject(TenantContextService);
    const router    = inject(Router);

    const claims = await firstValueFrom(tenantCtx.claims$);

    if (claims?.role !== 'super_admin') {
        return router.parseUrl('dashboard');
    }

    return true;
};
